module.exports = __webpack_public_path__ + "img/vrbee-logo.9be824fa.svg";